import React, { Component, FC } from "react";
import Input from "../input/Input";
import { FieldHorizontal } from "../form/Form";
import classNames from "classnames";
import {
  ComposantAllProps,
  ColorProps,
  SizeProps,
  getColorsClasses,
  getSizeClasses
} from "composants/common";
import { format } from "date-fns";
import { useMacOSDatePicker } from "utils/platform.utils";

export interface CalendarHoursProps extends ComposantAllProps {
  defaultAppearance?: boolean;
}

export const CalendarHours = ({ value, defaultAppearance, ...restProps }: CalendarHoursProps) => {
  const finalValue = format(value, "YYYY-MM-DDTHH:mm");
  const { inputRef, isMacOS, handleFocus, handleMouseDown } = useMacOSDatePicker();

  return (
    <Input
      {...restProps}
      ref={inputRef}
      data-initial-appearance={defaultAppearance || isMacOS}
      type="datetime-local"
      value={value ? finalValue : ""}
      data-value={value ? finalValue : ""}
      onFocus={e => handleFocus(e, restProps.onFocus)}
      onMouseDown={e => handleMouseDown(e, restProps.onMouseDown)}
    />
  );
};

export default CalendarHours;
